import Vue from 'vue'

const SET_RESPONSE = (state,objDados) => {
	state.objDados = objDados
}

export{
	SET_RESPONSE
}
